import React from 'react';

import { View, StyleSheet, Text } from 'react-native';

import { OPComponent, IconRow, Utils, I18n } from '../components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getEditingCase,
  getEditingCasePatient,
  getEditingCaseEmployer,
  getEditingCasePatientProfile,
} from './selector';

import { THEME, FONT, FONT_SIZE, COLOR } from '../../constants/styles';

import { INVITATIONS, PATIENT_INFO, RESIDENT_ADMINISTRATION } from '../../constants/permissions';
import { editingCasePermissions } from '../../helpers/permissions';

import PatientInfo from '../patient/patient_info';

class CaseInfoEmployer extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const props = this.props;
    const { employer } = props;

    if (!employer || !props.canViewEditingCase) return null;

    // in the comp this is an icon
    const imageSource = { uri: Utils.employerImagePath(employer.employerId) };

    return (
      <View>
        <IconRow
          imageSource={imageSource}
          label={I18n.aec('case.residentOf')}
          value={employer.name}
          topBorder={true}
          bottomBorder={false}
        />
        <PatientInfo />
      </View>
    );
  }
}

const styles = StyleSheet.create({});

function mapStateToProps(state, ownProps) {
  return {
    employer: getEditingCaseEmployer(state),
    editingCase: getEditingCase(state),
    editingCasePatient: getEditingCasePatient(state),
    canViewEditingCase: editingCasePermissions(RESIDENT_ADMINISTRATION).canView,
    canEditPatientInvites: editingCasePermissions(INVITATIONS).canEdit,
    patientProfile: getEditingCasePatientProfile(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseInfoEmployer);
